// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"K2-z"};